export default __webpack_public_path__ + "static/media/btn-remove-photo.08e2f282.svg";